import useWindowDimensions from "./useWindowDimensions";

const useIsMobileView = () => {
  const { windowWidth } = useWindowDimensions();
  return windowWidth > 768 ? false : true;
};

export default useIsMobileView;
